import { router, useFocusEffect } from "expo-router";
import { useCallback } from "react";
import { View } from "react-native";

/**
 * Legacy redirect — the v2 Find Competition flow is unified at
 * /student/find (left rail + right card grid). The /student/find/[tier]
 * route is kept only so existing deep links don\'t 404.
 */
export default function FindLegacyTierRedirect() {
  useFocusEffect(
    useCallback(() => {
      router.replace("/student/find");
    }, [])
  );
  return <View />;
}
